import React, { useEffect } from "react";
import { Spin } from "antd";
import "./style.css";

const index = () => {

  useEffect(() => {
    // openChild({
    //   url: "http://39.104.136.10:3012",
    //   // url: 'http://localhost:3000',
    //   mobile: "18301389086",
    //   password: "123456",
    // });
  }, []);
  return  (<div id="ljfDom">
  <div className="order_dom">
    <Spin></Spin>
  </div>
</div>)
};

export default index;
